export default __webpack_public_path__ + "static/media/seag_logo.312a6bb4.jpg";